
import axios from 'axios';




async function GetAndroidApps() {
    try {
        const response = await axios.post("https://apiv2.mobileartsme.com/af_getapps_new",
            { platformId: "0" },
        );

        const res = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
        const data = res.Result;

        const apkApps = [];
        const googleplay = [];
        const huawei = [];

        data.forEach(app => {
            if (app.StoreLink === null) {
                apkApps.push({ ...app, Screenshots: app.Screenshots || [] });
            } else if (app.StoreLink.includes("appgallery.huawei.com")) {
                huawei.push({ ...app, Screenshots: app.Screenshots || [] });
            } else {
                if (app.Platform != "IOS") {
                    googleplay.push({ ...app, Screenshots: app.Screenshots || [] });
                }
            }
        });

        return { apkApps, googleplay, huawei };
    } catch (error) {
        console.error("Error fetching Android apps:", error);
        return { apkApps: [], googleplay: [], huawei: [] };
    }
}

async function GetIOSApps() {
    try {
        const response = await axios.post(
            "https://apiv2.mobileartsme.com/af_getapps_new",
            { platformId: "3" },
            {
                headers: { 'Content-Type': 'application/json' },

            }
        );

        const res = response.data.Result;
        return res || [];
    } catch (error) {
        console.error("Error fetching iOS apps:", error);
        return [];
    }
}

async function GetGames() {
    try {
        const response = await axios.get("https://apiv2.mobileartsme.com/gbox_getcontent_new",
            {
                headers: { 'Content-Type': 'application/json' },
                mode: 'no-cors',
            }
        );

        const res = response.data.Content[0].HTML5;

        return res || [];
    } catch (error) {
        console.error("Error fetching games:", error);
        return [];
    }
}

async function GetVideos() {
    try {
        const response = await axios.get(
            "https://apiv2.mobileartsme.com/mobibase_content?language=en&ispremium=true",

        );

        const res = response.data.Content[0].Videos;
        return res || [];
    } catch (error) {
        console.error("Error fetching videos:", error);
        return [];
    }
}

async function GetLiveChannels() {
    try {
        const response = await axios.get(
            "https://apiv2.mobileartsme.com/av_tvchannels",
            {
                headers: { 'Content-Type': 'application/json' },
                mode: 'no-cors',
            }
        );

        return response.data.Channels || [];
    } catch (error) {
        console.error("Error fetching live channels:", error);
        return [];
    }
}


export async function GetAllData() {
    // Check if all data exists in session storage
    const storedData = sessionStorage.getItem('AF_AllData');
    if (storedData) {
        return JSON.parse(storedData);
    }

    const AndroidAppsRaw = await GetAndroidApps();
    const IOSApps = await GetIOSApps();
    const Games = await GetGames();
    const Videos = await GetVideos();
    const LiveChannels = await GetLiveChannels();

    let allData;

    try {
        const countryRes = await axios.get("https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry");
        const country = countryRes.data;

        if (country === "AE") {
            const excludedNames = ["Laki", "Laki Pro", "Games Box", "Amazing Videos"];

            const AndroidApps = {
                apkApps: AndroidAppsRaw.apkApps.filter(app => !excludedNames.includes(app.AppName)),
                googleplay: AndroidAppsRaw.googleplay.filter(app => !excludedNames.includes(app.AppName)),
                huawei: AndroidAppsRaw.huawei.filter(app => !excludedNames.includes(app.AppName)),
            };

            const IOSAppsFiltered = IOSApps.filter(app => !excludedNames.includes(app.AppName));

            allData = {
                AndroidApps,
                IOSApps: IOSAppsFiltered,
                Games,
                Videos,
                LiveChannels,
            };
        } else {
            allData = {
                AndroidApps: AndroidAppsRaw,
                IOSApps,
                Games,
                Videos,
                LiveChannels,
            };
        }
    } catch (error) {
        console.error("Error getting country or processing data:", error);
        // Fallback to returning raw data
        allData = {
            AndroidApps: AndroidAppsRaw,
            IOSApps,
            Games,
            Videos,
            LiveChannels,
        };
    }

    sessionStorage.setItem('AF_AllData', JSON.stringify(allData));

    return allData;
}




export function Logout() {
    sessionStorage.removeItem("AF_Login_Data")
    window.location.reload()
}


function checkurl() {

    const params = new URL(window.location.href).searchParams;

    console.log("PARAMS : ",params)

    const phone = params.get("Phonenumber");
    const IDProvider = params.get("IDPaymentProvider");


    if (phone && IDProvider) {
        console.log(phone)
        fetch(`https://apiv2.mobileartsme.com/LoginWithoutPass?IDService=1&MSISDN=${phone}&IDProvider=${IDProvider}`)
            .then(response => response.json())
            .then(data => {

                if (data.Error === 0) {
                    if (data.Result.Description === "Subscription Active") {

                        const userData = {
                            ...data.Result,
                            phone: phone
                        };
                        sessionStorage.setItem('AF_Login_Data', JSON.stringify(userData));
                        window.location.href = "/application";
                    }
                }

            })
    } else {
        console.log('no phone')
    }

}




async function AutoLogin() {

  
    const AF_Login_Data = sessionStorage.getItem("AF_Login_Data");
    const urlParams = window.location.pathname;

    if (urlParams === '/' && AF_Login_Data) {
        window.location.href = '/application';

    }
    else if (urlParams !== "/" && !AF_Login_Data && urlParams !== "/AppDetails" && urlParams !== "/ContactUs") {
        window.location.href = '/';
    }

}




AutoLogin()

export { GetAndroidApps, GetIOSApps, GetGames, GetVideos, GetLiveChannels , checkurl};
